module.exports = __webpack_public_path__ + "img/loto_color.19e69692.png";